import { useMemo, useCallback } from 'react';
import { useMachine } from '@xstate/react';

import machine from './machine';

export default function useCaptureFieldState() {
  const [state, send] = useMachine(machine);

  const toggleViewAll = useCallback(() => send('TOGGLE_SHOW_ALL'), []);

  const isViewingAll = useMemo(() => state.matches('allOptions'), [state]);

  return {
    isViewingAll,
    toggleViewAll,
  };
}
